module.exports = __webpack_public_path__ + "img/chevron.b8544212.svg";